/* import __COLOCATED_TEMPLATE__ from './single-event.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { cached, tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { DateTime } from 'luxon';
import { findById } from 'ilios-common/utils/array-helpers';
import createTypedLearningMaterialProxy from 'ilios-common/utils/create-typed-learning-material-proxy';
import { TrackedAsyncData } from 'ember-async-data';
let SingleEvent = (_class = class SingleEvent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "currentUser", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _initializerDefineProperty(this, "store", _descriptor3, this);
    _initializerDefineProperty(this, "router", _descriptor4, this);
    _initializerDefineProperty(this, "isSessionMaterialsListExpanded", _descriptor5, this);
    _initializerDefineProperty(this, "isCourseMaterialsListExpanded", _descriptor6, this);
    _defineProperty(this, "userIsStudentData", new TrackedAsyncData(this.currentUser.getIsStudent()));
  }
  get userIsStudent() {
    return this.userIsStudentData.isResolved ? this.userIsStudentData.value : false;
  }
  get courseId() {
    return this.args.event.course;
  }
  get startsAndEndsOnSameDay() {
    const startDate = new Date(this.args.event.startDate);
    const endDate = new Date(this.args.event.endDate);
    return startDate.getDate() === endDate.getDate() && startDate.getFullYear() === endDate.getFullYear() && startDate.getMonth() === endDate.getMonth();
  }
  get taughtBy() {
    const instructors = this.args.event.instructors;
    if (isEmpty(instructors)) {
      return '';
    }
    return this.intl.t('general.taughtBy', {
      instructors: instructors.join(', ')
    });
  }
  get courseObjectives() {
    const objectives = this.args.event.courseObjectives || [];
    const competencies = this.args.event.competencies || [];
    return objectives.map(objective => {
      const position = objective.position;
      if (isEmpty(objective.competencies)) {
        return {
          id: objective.id,
          title: objective.title,
          domain: this.intl.t('general.noAssociatedCompetencies'),
          position
        };
      }
      const competencyId = objective.competencies[0];
      const competency = findById(competencies, competencyId);
      const parentId = competency.parent;
      let domain = competency;
      if (!isEmpty(parentId)) {
        domain = findById(competencies, parentId);
      }
      return {
        id: objective.id,
        title: objective.title,
        domain: competency.title + ' (' + domain.title + ')',
        position
      };
    }).sort(this.positionSortingCallback);
  }
  get typedLearningMaterials() {
    const lms = this.args.event.learningMaterials || [];
    return this.getTypedLearningMaterialProxies(lms);
  }
  get courseLearningMaterials() {
    const eventLms = this.typedLearningMaterials;
    return eventLms.filter(lm => Boolean(lm.courseLearningMaterial)).sort((lm1, lm2) => {
      const pos1 = parseInt(lm1.position, 10) || 0;
      const pos2 = parseInt(lm2.position, 10) || 0;

      // 1. position, asc
      if (pos1 > pos2) {
        return 1;
      } else if (pos1 < pos2) {
        return -1;
      }

      // 2. course learning material id, desc
      const id1 = lm1.courseLearningMaterial;
      const id2 = lm2.courseLearningMaterial;
      if (id1 > id2) {
        return -1;
      } else if (id1 < id2) {
        return 1;
      }
      return 0;
    });
  }
  get sessionObjectives() {
    const objectives = this.args.event.sessionObjectives || [];
    const competencies = this.args.event.competencies || [];
    return objectives.map(objective => {
      const position = objective.position;
      if (isEmpty(objective.competencies)) {
        return {
          id: objective.id,
          title: objective.title,
          domain: this.intl.t('general.noAssociatedCompetencies'),
          position
        };
      }
      const competencyId = objective.competencies[0];
      const competency = findById(competencies, competencyId);
      const parentId = competency.parent;
      let domain = competency;
      if (!isEmpty(parentId)) {
        domain = findById(competencies, parentId);
      }
      return {
        id: objective.id,
        title: objective.title,
        domain: competency.title + ' (' + domain.title + ')',
        position
      };
    }).sort(this.positionSortingCallback);
  }
  get sessionLearningMaterials() {
    const eventLms = this.typedLearningMaterials;
    return eventLms.filter(lm => Boolean(lm.sessionLearningMaterial)).sort(this.sessionLearningMaterialSortingCalling);
  }
  get preworkMaterials() {
    if (!this.args.event.prerequisites) {
      return [];
    }
    return this.args.event.prerequisites.map(ev => {
      const rhett = {
        name: ev.name,
        slug: ev.slug,
        learningMaterials: []
      };
      rhett.learningMaterials = this.getTypedLearningMaterialProxies(ev.learningMaterials).filter(lm => Boolean(lm.sessionLearningMaterial)).sort(this.sessionLearningMaterialSortingCalling);
      return rhett;
    });
  }
  get recentlyUpdated() {
    const lastModifiedDate = DateTime.fromISO(this.args.event.lastModified);
    const today = DateTime.now();
    const daysSinceLastUpdate = today.diff(lastModifiedDate, 'days').days;
    return daysSinceLastUpdate < 6;
  }
  get postrequisiteLink() {
    if (this.args.event.postrequisites.length) {
      return this.router.urlFor('events', this.args.event.postrequisites[0].slug);
    }
    return '';
  }
  get canViewCourse() {
    return this.currentUser.performsNonLearnerFunction;
  }
  get sessionRouteExists() {
    try {
      this.router.urlFor('session', this.args.event.course, this.args.event.session);
    } catch (e) {
      return false;
    }
    return true;
  }
  get canViewSession() {
    return this.currentUser.performsNonLearnerFunction;
  }
  transitionToMyMaterials() {
    this.router.transitionTo('dashboard.materials', {
      queryParams: {
        show: 'materials',
        course: this.courseId,
        showAll: true
      }
    });
  }

  /**
   * Callback function for <code>Array.sort()<code>.
   * Compares two given Objects by their position property (in ascending order), and then by id (descending).
   *
   * @method positionSortingCallback
   * @param {Object} obj1
   * @param {Object} obj2
   * @return {Number}
   */
  positionSortingCallback(obj1, obj2) {
    const pos1 = obj1.position;
    const pos2 = obj2.position;
    // 1. position, asc
    if (pos1 > pos2) {
      return 1;
    } else if (pos1 < pos2) {
      return -1;
    }

    // 2. id, desc
    const id1 = obj1.id;
    const id2 = obj2.id;
    if (id1 > id2) {
      return -1;
    } else if (id1 < id2) {
      return 1;
    }
    return 0;
  }
  getTypedLearningMaterialProxies(lms) {
    return lms.map(lm => {
      return createTypedLearningMaterialProxy(lm);
    });
  }
  sessionLearningMaterialSortingCalling(lm1, lm2) {
    const pos1 = parseInt(lm1.position, 10) || 0;
    const pos2 = parseInt(lm2.position, 10) || 0;

    // 1. position, asc
    if (pos1 > pos2) {
      return 1;
    } else if (pos1 < pos2) {
      return -1;
    }

    // 2. session learning material id, desc
    const id1 = lm1.sessionLearningMaterial;
    const id2 = lm2.sessionLearningMaterial;
    if (id1 > id2) {
      return -1;
    } else if (id1 < id2) {
      return 1;
    }
    return 0;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "currentUser", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "isSessionMaterialsListExpanded", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "isCourseMaterialsListExpanded", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "userIsStudent", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "userIsStudent"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "transitionToMyMaterials", [action], Object.getOwnPropertyDescriptor(_class.prototype, "transitionToMyMaterials"), _class.prototype), _class);
export { SingleEvent as default };